/**
 * Created by mac on 9/29/26
 *
 * LikePraise adapter for yatzy: a "move" is scoring a row. The praise pop-up sits above the dice
 * tray. See aisensia/src/likepraise/likepraise.js for the contract.
 */

class YatzyLikePraiseAdapter {
    constructor(dicesView) {
        this.dicesView = dicesView;
        this.tutorial = undefined;
    }

    get anchor() {
        return cc.p(0.5, 1);
    }

    getWorldPosition() {
        if (!this.dicesView || !this.dicesView.isRunning()) {
            return undefined;
        }
        const box = this.dicesView.getGlobalBoundingBox();
        return cc.p(box.x + box.width / 2, box.y + box.height + YatzyLikePraiseAdapter.GAP);
    }
}

YatzyLikePraiseAdapter.GAP = 20;
